import { render } from "./MatrixSupport.vue?vue&type=template&id=2f046328&scoped=true"
import script from "./MatrixSupport.vue?vue&type=script&lang=js"
export * from "./MatrixSupport.vue?vue&type=script&lang=js"

import "./MatrixSupport.vue?vue&type=style&index=0&id=2f046328&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f046328"]])

export default __exports__